import React, { Component } from 'react'
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import Responsive from '../../components/Responsive';
import { checkTranslation, conditionalWidth, translate } from '../../utils/useful';
import StagesManager from '../../components/StagesManager';
import FormViewer from '../../components/FormViewer';
import HttpServices from '../../utils/Http.services';
import SwitchInput from '../../components/inputs/SwitchInput';
import HelpButton from '../../components/HelpButton';
import CommerceCart from './CommerceCart';
import { duration } from 'jalali-moment';
import { siteConfig } from '../../variables/config';

export default class YonnectCartPage extends Component {
    state = {
        display: true,
        data: {},
        currentPlan: "Team",
        pricingData: [

            // {
            //     title: '{{lang}}Starter', key: 'starter', desc: '{{lang}}The essentials to get your team up and running',
            //     price: { monthly: 0, yearly: 0 }, users: '{{lang}}Up to 5 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 0 }],
            //     level: 0,
            //     options: {
            //         list: [
            //             { text: '{{lang}}Up to 5 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}5 GB cloud storage' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Up to 10 applets' },
            //             { text: '{{lang}}Up to 10,000 records per collection' },
            //             { text: '{{lang}}up to 10 frames per applet' },
            //             // '{{lang}}Up to 60 minutes meeting duration',
            //         ]
            //     }
            // },


            // {
            //     title: '{{lang}}Team', key: 'team', desc: '{{lang}}The essentials to get your team up and running',
            //     price: { monthly: 35, yearly: 29 }, users: '{{lang}}Up to 50 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 0 }],
            //     level: 1,
            //     options: {
            //         list: [
            //             { text: '{{lang}}Up to 50 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}5 GB cloud storage per license', desc: '{{lang}}The total storage will be available for the whole hub and the storage will not be alocated to users. e.g. 30 licenses will give your hub 150 GB cloud storage.' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Up to 100 applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //             // '{{lang}}Can connect emails',

            //         ]
            //     }
            // },

            // {
            //     title: '{{lang}}Professional', key: 'professional', desc: '{{lang}}Advanced tools to take your growing team to the next level',
            //     price: { monthly: 47, yearly: 39 }, users: '{{lang}}Up to 5000 users',
            //     buttons: [{ title: '{{lang}}Select', function: '', status: 2 }],
            //     level: 2,
            //     options: {
            //         title: '{{lang}}Everything in Starter, plus:', list: [
            //             { text: '{{lang}}Up to 5,000 licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}10 GB cloud storage per license', desc: '{{lang}}The total storage will be available for the whole hub and the storage will not be alocated to users. e.g. 3000 licenses will give your hub 15 TB cloud storage.' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Unlimited applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //         ]
            //     }
            // },
            // {
            //     title: '{{lang}}Enterprise', key: 'enterprise', desc: '{{lang}}More features and data to transform your team',
            //     priceLabel: "{{lang}}Let's talk", users: '{{lang}}Unlimited users',
            //     buttons: [{ title: '{{lang}}Contact sales', function: '', status: 1, isContact: true }],
            //     options: {
            //         title: '{{lang}}Everything in Pro, plus:', list: [
            //             { text: '{{lang}}Unlimited licenses', desc: '{{lang}}Any user and hub needs a valid license to be able to have access to any private applet. User perspective of Public applets does not need license for access.' },
            //             { text: '{{lang}}Custom cloud storage' },
            //             { text: '{{lang}}Unlimited connections', desc: '{{lang}}Unlimited users and businesses can connect to your hub and applets based on the limitations you setup.' },
            //             { text: '{{lang}}Unlimited applets' },
            //             { text: '{{lang}}Unlimited records per collection' },
            //             { text: '{{lang}}Unlimited frames per applet' },
            //         ]
            //     }
            // },
        ],

        headers: [
            { key: 'invoice', type: 'InvoiceInput2', information: { required: true, placeholder: '{{lang}}Quantity', } },
        ],

        formHeaders: [
            { key: 'country', type: 'TextInput', col: '6', information: { label: '{{lang}}Country/Region', required: true, placeholder: '{{lang}}Country', } },
            { key: 'province', type: 'TextInput', col: '6', information: { label: '{{lang}}Province/State', required: true, placeholder: '{{lang}}Province', } },
            { key: 'city', type: 'TextInput', col: '6', information: { label: '{{lang}}City', required: true, placeholder: '{{lang}}City', } },
            { key: 'zipcode', type: 'NumberInput', col: '6', information: { label: '{{lang}}Zip Code', required: true, placeholder: '{{lang}}Zip Code', type: 'api', address: 'searchUser', filter: {}, fields: { title: 'fullname', value: '_id', description: 'username', image: 'image' } } },
            { key: 'company', type: 'TextInput', col: '6', information: { label: '{{lang}}Company', required: true, placeholder: '{{lang}}Company', } },
            { key: 'address', type: 'TextInput', col: '6', information: { label: '{{lang}}Address', required: true, placeholder: '{{lang}}Address', } },
            { key: 'taxId', type: 'NumberInput', col: '6', information: { label: '{{lang}}Tax ID', required: false, placeholder: '{{lang}}Tax ID', } },
        ],

        priceHeaders: [
            { key: 'quantity', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Quantity', label: '{{lang}}Quantity', } },
            // { key: 'service', col: '6', type: 'NumberInput', information: { required: true, placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'serviceTime', col: '6', type: 'SelectInput', information: { required: true, items: [{ title: '{{lang}}Monthly', value: 'monthly' }, { title: '{{lang}}Yearly', value: 'yearly' }], placeholder: '{{lang}}Service period', label: '{{lang}}Service period (by Year)', } },
            { key: 'subscription', col: '12', type: 'SwitchInput', information: { placeholder: '{{lang}}Subscription', label: '{{lang}}Subsctiption', } },
        ]
    }

    componentDidMount() {
        // if (this.props.setHeader) {
        //     this.props.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         'info': 'Create Hub | Pricing',
        //         topHeaderComponent: this.topHeaderComponent,
        //         backAction: () => this.props.changePage(['accountSettings'])
        //     })
        // }

        // setTimeout(() => {
        //     this.fetchPriceData() 
        // }, 500);

    }


    // fetchPriceData = () => {

    //     let body = {
    //         applet: '66437fe0866feba9035be16e',
    //         appletHub: '66437a69866feba9035bdd5f'
    //     }
    //     HttpServices.request('getProducts', body, (fetchResult, fetchError) => {

    //         // console.log(fetchResult)
    //         if (fetchError) {
    //             return
    //         }

    //         let currentPlan = this.state.currentPlan
    //         let currentLevel
    //         let pricingData = fetchResult.info
    //         let prices = {}
    //         let priceDurations = []
    //         let pricingConfig = {}
    //         let currentDuration
    //         let sort = ['Starter', 'Team', 'Professional', 'Enterprise']
    //         let showSaving = true

    //         pricingData.sort((a, b) => sort.indexOf(a.name) - sort.indexOf(b.name));



    //         pricingData.forEach((element, index) => {

    //             if (element.name == currentPlan) {
    //                 currentLevel = index
    //             }



    //             if (element.priceType == 'subscription') {
    //                 if (Array.isArray(element.subscriptionPrice)) {

    //                     prices[element._id] = {}


    //                     element.subscriptionPrice.forEach(sprice => {


    //                         prices[element._id][(sprice.repeat ?? '1') + "-" + sprice.duration] = { price: sprice.price, duration: sprice.duration, repeat: sprice.repeat }

    //                         let found = false
    //                         priceDurations.forEach(pduration => {
    //                             if (pduration.duration == sprice.duration && pduration.repeat == sprice.repeat) {
    //                                 found = true
    //                             }
    //                         });

    //                         if (!found) {
    //                             let label = sprice.duration
    //                             if ((sprice.repeat ?? 1) == 1) {
    //                                 if (sprice.duration == 'year') {
    //                                     label = '{{lang}}Yearly'
    //                                 }
    //                                 if (sprice.duration == 'month') {
    //                                     label = '{{lang}}Monthly'
    //                                 }
    //                                 if (sprice.duration == 'week') {
    //                                     label = '{{lang}}Weekly'
    //                                 }
    //                             } else {
    //                                 label = `${sprice.repeat} ${sprice.duration}s`
    //                             }

    //                             priceDurations.push({ duration: sprice.duration, repeat: sprice.repeat, key: (sprice.repeat ?? '1') + "-" + sprice.duration, label })

    //                         }

    //                     })
    //                 }
    //             }

    //         })

    //         if (priceDurations.length > 0) {
    //             let samePricing = true

    //             priceDurations.forEach(pDuration => {

    //                 if (!currentDuration) {
    //                     currentDuration = pDuration
    //                 } else {

    //                     if (currentDuration.duration == 'week' && ((pDuration.duration == 'month' || pDuration.duration == 'year') || (pDuration.duration == 'week' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
    //                         currentDuration = pDuration
    //                     }

    //                     if (currentDuration.duration == 'month' && ((pDuration.duration == 'year') || (pDuration.duration == 'month' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
    //                         currentDuration = pDuration
    //                     }

    //                     if (currentDuration.duration == 'year' && ((pDuration.duration == 'year' && (pDuration.repeat ?? 1 > (currentDuration.repeat ?? 1))))) {
    //                         currentDuration = pDuration
    //                     }

    //                 }

    //                 if (currentDuration.duration == 'year') {
    //                     showSaving = true
    //                 }

    //                 pricingData.forEach(element => {

    //                     if (element.priceType == 'subscrition') {
    //                         let found = false
    //                         element.subscriptionPrice.forEach(sprice => {
    //                             if (pDuration.duration == sprice.duration && pDuration.repeat == sprice.repeat) {
    //                                 found = true
    //                             }
    //                         })

    //                         if (!found) {
    //                             samePricing = false
    //                         }
    //                     }
    //                 })

    //             })

    //             pricingConfig.samePricing = samePricing
    //         }

    //         if (priceDurations.length == 2) {

    //             pricingConfig.showSwitch = true

    //         }

    //         if (priceDurations.length > 1 && showSaving) {
    //             pricingConfig.showSaving = true
    //         }


    //         let durationSort = ['week', 'moth', 'year']

    //         priceDurations.sort((a, b) => durationSort.indexOf(a.duration) - durationSort.indexOf(b.duration) || (a.repeat ?? 1) - (b.repeat ?? 1));



    //         // console.log(priceDurations)
    //         // console.log(pricingConfig)
    //         // console.log(prices)

    //         this.setState({ pricingData, pricesInfo: prices, priceDurations, pricingConfig, currentLevel, currentDuration })



    //     })
    // }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.checkOut}
                    isLoading={this.state.isLoading}
                    title={translate("{{lang}}Check Out")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>
        )
    }
    checkOut = () => {
        // console.log('this.props.data', this.props)
        let data = this.priceForm.getForm()
        let billing = this.form.getForm()
        if (data && billing) {
            // console.log('firstdata', data)
            // let body = { quantity: data?.quantity, serviceType: data?.serviceType, subscription: data?.subscription, expiry: { value: data?.service, unit: 'year' } }
            let body = { ...{ serviceInfo: data }, ...billing }
            HttpServices.request('checkoutWithStripe', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
                // console.log('fetchResult', fetchResult.info.url)
                window.location.href = fetchResult.info.url
            })
        }
    }
    


    render() {
        
        let variables = {
            appletId: siteConfig.yonnectSunscriptionApplet,
            appletHub: siteConfig.yonnectHub,
            targetHub: this.props.variables?.appletHub
        }

        return (
            <div className=" w-100 h-100" style={{}}>
                <StagesManager height={'100%'} ref={el => this.stageManager = el} >


                    <div stage={0} stageName={'cart'} className=" w-100 h-100  position-relative window-content-radius" style={{}}>
                        <CommerceCart language={this.props.language} getCart={this.getCart} addToCart={this.addToCart} cart={this.state.cart} windowData={this.props.windowData} colors={this.props.colors} changePage={this.changePage} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} applet={this.props.applet} pages={this.state.pages} width={this.props.width} height={this.props.height} page={this.state.page} stage={1} user={this.props.user} setUser={this.setUser} changeWindowLink={this.changeWindowLink} addNotif={this.addNotif} history={this.props.history} route={this.props.route} variables={variables} />
                    </div>

                </StagesManager>

            </div>
        )
    }
}
